import React, { useCallback, useMemo } from "react";
import Reservation from "./Reservation";
import { AnimatePresence } from "motion/react";
import PullToRefresh from "components/PullToRefresh";

function compareTime(aTime, bTime) {
  const [aHours, aMinutes] = aTime.split(":").map(Number);
  const [bHours, bMinutes] = bTime.split(":").map(Number);
  if (aHours !== bHours) {
    return aHours - bHours;
  } else {
    return aMinutes - bMinutes;
  }
}

function ReservationDisplayer(props) {
  const {
    liveRes,
    cancelledRes,
    patchRes,
    setResModal,
    loading,
    handleReload,
    onContextMenu,
  } = props;

  const handleBtnClick = useCallback(
    (res, state) => patchRes(res, state),
    [patchRes]
  );

  const sortedLiveRes = useMemo(
    () => [...liveRes].sort((a, b) => compareTime(a.time, b.time)),
    [liveRes]
  );

  const sortedCancelledRes = useMemo(
    () => [...cancelledRes].sort((a, b) => compareTime(a.time, b.time)),
    [cancelledRes]
  );

  function mapReservations(resToMap) {
    return resToMap.map((res) => (
      <div
        key={res._id}
        style={{
          display: "flex",
          flexDirection: "column",
          height: "max-content",
        }}
      >
        <Reservation
          res={res}
          handleBtnClick={handleBtnClick}
          setResModal={setResModal}
          onContextMenu={onContextMenu}
        />
      </div>
    ));
  }

  if (loading) return "";

  if (
    !loading &&
    sortedLiveRes.length === 0 &&
    sortedCancelledRes.length === 0
  ) {
    return (
      <PullToRefresh onRefresh={handleReload}>
        <div
          style={{
            display: "flex",
            width: "100%",
            height: "50vh",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h1>No Reservations</h1>
        </div>
      </PullToRefresh>
    );
  }

  return (
    <PullToRefresh onRefresh={handleReload}>
      <div>
        <div
          id="reservations"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            width: "100%",
          }}
        >
          <AnimatePresence>
            {sortedLiveRes && sortedLiveRes.length > 0 && (
              <div className="reservations-displayer">
                {mapReservations(sortedLiveRes)}
              </div>
            )}
            {sortedCancelledRes && sortedCancelledRes.length > 0 && (
              <div className="cancelled-res">
                <div className="cancelled-text">Cancelled</div>
                {mapReservations(sortedCancelledRes)}
              </div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </PullToRefresh>
  );
}

export default ReservationDisplayer;
